<template>
    <div class="form-wrapper">
        <div class="form-boxes-wrapper">
        <h3>Lorem ipsum!</h3>
            <div>
                <div class="form-box">
                    <div class="input-box" :class="{ error: checkError(1) }">
                        <input type="text" required>
                        <span class="label">Imię i nazwisko</span>
                        <transition name="expand">
                            <div class="error" v-if="checkError(1)">
                                <span>Nieudana walidacja</span>
                            </div>
                        </transition>
                    </div>
                </div>
                <div class="form-box">
                    <div class="input-box" :class="{ error: checkError(2) }">
                        <input type="text" required>
                        <span class="label">Imię i nazwisko</span>
                        <transition name="expand">
                            <div class="error" v-if="checkError(2)">
                                <span>Nieudana walidacja</span>
                            </div>
                        </transition>
                    </div>
                    <div class="input-box" :class="{ error: checkError(3) }">
                        <input type="text" required>
                        <span class="label">Imię i nazwisko</span>
                        <transition name="expand">
                            <div class="error" v-if="checkError(3)">
                                <span>Nieudana walidacja</span>
                            </div>
                        </transition>
                    </div>
                </div>
                <div class="form-box">
                    <div class="input-box" :class="{ error: checkError(4) }">
                        <input type="text" required>
                        <span class="label">Imię i nazwisko</span>
                        <transition name="expand">
                            <div class="error" v-if="checkError(4)">
                                <span>Nieudana walidacja</span>
                            </div>
                        </transition>
                    </div>
                    <div class="input-box" :class="{ error: checkError(5) }">
                        <input type="text" required>
                        <span class="label">Imię i nazwisko</span>
                        <transition name="expand">
                            <div class="error" v-if="checkError(5)">
                                <span>Nieudana walidacja</span>
                            </div>
                        </transition>
                    </div>
                    <div class="input-box" :class="{ error: checkError(6) }">
                        <input type="text" required>
                        <span class="label">Imię i nazwisko</span>
                        <transition name="expand">
                            <div class="error" v-if="checkError(6)">
                                <span>Nieudana walidacja</span>
                            </div>
                        </transition>
                    </div>
                </div>
                <div class="form-box">
                    <div class="input-box textarea" :class="{ error: checkError(7) }">
                        <textarea cols="30" rows="20" required></textarea>
                        <span class="label">Imię i nazwisko</span>
                        <transition name="expand">
                            <div class="error" v-if="checkError(7)">
                                <span>Nieudana walidacja</span>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
            <button>Wyślij</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Form2',
    data() {
        return {
            error: [1],
        }
    },
    methods: {
        checkError(index) {
            if(this.error.includes(index)) {
                return 1;
            } else {
                return 0;
            };
        },
    },
}
</script>

<style lang="scss" scoped>
    h3 {
        margin: 0;
        color: #fff;
        font-size: 40px;
        letter-spacing: 1px;
    }
    .form-wrapper {
        width: 100vw;
        min-height: calc(100vh - 70px);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: #000;
        background-image: url('https://images.unsplash.com/photo-1603042293225-e7d880f97d46?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1267&q=80');
        background-size: cover;
    }
    .form-boxes-wrapper {
        background: rgba(#000, .7);
        width: 100%;
        min-height: calc(100vh - 70px);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 70px 0;
    }
    .form-box {
        width: 90vw;
        max-width: 1000px;
        display: flex;
        justify-content: center;
    }
    .input-box {
        width: 100%;
        margin: 10px;
        position: relative;
    }
    .input-box input,
    .input-box textarea {
        width: 100%;
        border: none;
        border-bottom: 1px solid #f8f8f8;
        outline: none;
        background: transparent;
        color: #fff;
    }
    .input-box textarea {
        border: 1px solid #f8f8f8;
    }
    .input-box textarea {
        resize: none;
        padding: 15px;
        padding-top: 25px;
    }
    .input-box input {
        height: 40px;
        padding: 0;
        padding-top: 5px;
    }
    .input-box span.label {
        position: absolute;
        left: 0px;
        top: calc(50% - 7px);
        font-size: 13px;
        pointer-events: none;
        color: #f8f8f8;
        background: transparent;
        transition: 0.2s ease all;
    }
    .input-box.textarea span.label {
        top: 25px;
        left: 15px;
    }
    .input-box input:focus ~ span.label,
    .input-box input:not(:focus):valid ~ span.label,
    .input-box textarea:focus ~ span.label,
    .input-box textarea:not(:focus):valid ~ span.label {
        color: #fff;
        font-size: 10px;
        top: 0;
        margin-bottom: 3px;
    }
    .input-box textarea:focus ~ span.label,
    .input-box textarea:not(:focus):valid ~ span.label {
        top: 10px;
        left: 16px;
    }
    .input-box input:not(:focus):valid ~ span.label,
    .input-box textarea:not(:focus):valid ~ span.label {
        color: #f8f8f8;
    }
    .input-box input:focus ~ span.label,
    .input-box textarea:focus ~ span.label,
    .input-box input:focus,
    .input-box textarea:focus {
        font-weight: 600;
        border-width: 2px;
        border-image: linear-gradient(to right, #fff, #f8f8f8);
        border-image-slice: 1;
    }
    .input-box textarea:focus {
        padding-bottom: 14px;
        padding-top: 24px;
    }
    .input-box div.error {
        color: red;
        display: flex;
        align-items: center;
        font-size: 10px;
        position: absolute;
        left: 0;
        bottom: -15px;
        overflow: hidden;
    }
    .input-box.textarea div.error {
        bottom: -10px;
    }
    .input-box div.error i.material-icons {
        font-size: 15px;
        margin-right: 3px;
    }
    .input-box.error input,
    .input-box.error textarea {
        border-color: red;
    }
    .input-box.error input:focus ~ span.label,
    .input-box.error input:not(:focus):valid ~ span.label,
    .input-box.error textarea:focus ~ span.label,
    .input-box.error textarea:not(:focus):valid ~ span.label {
        color: red;
    }
    .input-box.error input:focus,
    .input-box.error textarea:focus {
        border-color: red;
        border-image: none;
    }
    .expand-enter-active,
    .expand-leave-active {
        transition: all .1s linear;
        max-height: 13px;
    }
    .expand-enter,
    .expand-leave-to {
        max-height: 0;
    }
    .form-wrapper button {
        margin-top: 20px;
        background: transparent;
        color: #fff;
        border: 1px solid #fff;
        padding: 15px;
        font-size: 20px;
        letter-spacing: 3px;
    }
    .form-wrapper button:hover {
        cursor: pointer;
        border-width: 2px;
        padding: 14px;
    } 
</style>
